var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pa-2" },
    [
      _c(
        "v-dialog",
        {
          attrs: { "content-class": "report-gen-dialog", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-3 report-gen-card" },
            [
              _c(
                "v-app-bar",
                {
                  attrs: { color: "#50596c", dark: "", height: "70px" },
                  scopedSlots: _vm._u([
                    {
                      key: "extension",
                      fn: function() {
                        return [
                          _c(
                            "v-tabs",
                            {
                              attrs: { right: "" },
                              model: {
                                value: _vm.reportTab,
                                callback: function($$v) {
                                  _vm.reportTab = $$v
                                },
                                expression: "reportTab"
                              }
                            },
                            [
                              _c("v-tabs-slider"),
                              _c("v-tab", { key: "tab-1" }, [
                                _vm._v(" System Selection ")
                              ]),
                              _c("v-tab", { key: "tab-2" }, [
                                _vm._v(" Report Topics ")
                              ])
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c("div", { staticClass: "pt-5 pl-3 text-left" }, [
                    _c("span", { staticClass: "pt-2 text-h4" }, [
                      _vm._v("Report Generator")
                    ]),
                    _c("div", { staticClass: "font-weight-light subtitle" }, [
                      _vm._v(
                        " Learn how timber systems impact overall building design and cost "
                      )
                    ])
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { fab: "", "x-small": "", outlined: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.reportTab,
                    callback: function($$v) {
                      _vm.reportTab = $$v
                    },
                    expression: "reportTab"
                  }
                },
                [
                  _c(
                    "v-tab-item",
                    { key: "tab-1" },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "bg-surface-light pt-4 text-left" },
                            [
                              _c("p", [
                                _vm._v(
                                  " Select which timber systems you would like to be included in the report: "
                                )
                              ]),
                              _c(
                                "v-container",
                                { staticClass: "container options-container" },
                                [
                                  _c("v-data-table", {
                                    staticClass:
                                      "v-step-10 searchable sortable options-table systems-table",
                                    attrs: {
                                      "show-select": "",
                                      "item-key": "SystemType",
                                      headers: _vm.headers,
                                      items: _vm.items,
                                      "items-per-page": 30,
                                      "item-class": _vm.rowClass,
                                      "hide-default-footer": true,
                                      height: "45vh",
                                      "mobile-breakpoint": "0",
                                      "fixed-header": ""
                                    },
                                    on: {
                                      "toggle-select-all":
                                        _vm.selectSystemsToggle
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.data-table-select",
                                        fn: function(ref) {
                                          var item = ref.item
                                          var isSelected = ref.isSelected
                                          var select = ref.select
                                          return [
                                            _c("v-simple-checkbox", {
                                              attrs: {
                                                value: isSelected,
                                                readonly:
                                                  item.MaterialType != "Timber",
                                                disabled:
                                                  item.MaterialType != "Timber"
                                              },
                                              on: {
                                                input: function($event) {
                                                  return select($event)
                                                }
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.selectedSystems,
                                      callback: function($$v) {
                                        _vm.selectedSystems = $$v
                                      },
                                      expression: "selectedSystems"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { key: "tab-2" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "reportTopics-tab-content pa-2 mx-auto"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " From the list below, select which topics you would like to be included in the report: "
                            )
                          ]),
                          _c("v-checkbox", {
                            staticClass: "select-all-chkbox",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              label: "Select All Topics"
                            },
                            on: {
                              change: function($event) {
                                return _vm.selectAllTopics($event)
                              }
                            },
                            model: {
                              value: _vm.selectAllTopicsToggle,
                              callback: function($$v) {
                                _vm.selectAllTopicsToggle = $$v
                              },
                              expression: "selectAllTopicsToggle"
                            }
                          }),
                          _c(
                            "div",
                            { staticClass: "pa-0" },
                            _vm._l(_vm.reportTopics, function(group, i) {
                              return _c(
                                "v-list",
                                { key: i, attrs: { subheader: "", dense: "" } },
                                [
                                  _c(
                                    "v-subheader",
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(group.TopicGroupName) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: { right: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  var attrs = ref.attrs
                                                  return [
                                                    _c(
                                                      "v-icon",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            right: "",
                                                            md: "",
                                                            size: "20"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " mdi-information "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(_vm._s(group.Tooltip))
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  group.Topics.length == 1 &&
                                  group.Topics[0].TopicName == "No"
                                    ? _c("v-switch", {
                                        staticClass: "pa-0 ma-0 pl-3",
                                        attrs: { "hide-details": "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "b",
                                                    {
                                                      class: [
                                                        "pl-3",
                                                        {
                                                          "primary--text":
                                                            group.Topics[0]
                                                              .IsSelected
                                                        }
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            group.Topics[0]
                                                              .IsSelected
                                                              ? "Yes"
                                                              : "No"
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: group.Topics[0].IsSelected,
                                          callback: function($$v) {
                                            _vm.$set(
                                              group.Topics[0],
                                              "IsSelected",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "group.Topics[0].IsSelected"
                                        }
                                      })
                                    : _c(
                                        "v-list-item-group",
                                        {
                                          attrs: {
                                            multiple: "",
                                            "active-class": ""
                                          },
                                          model: {
                                            value: group.selTopics,
                                            callback: function($$v) {
                                              _vm.$set(group, "selTopics", $$v)
                                            },
                                            expression: "group.selTopics"
                                          }
                                        },
                                        _vm._l(group.Topics, function(topic) {
                                          return _c("v-list-item", {
                                            key: topic.TopicId,
                                            attrs: { dense: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var active = ref.active
                                                    return [
                                                      _c(
                                                        "v-list-item-action",
                                                        [
                                                          _c("v-checkbox", {
                                                            attrs: {
                                                              dense: "",
                                                              "input-value": active
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.toggleSelectAll
                                                            },
                                                            model: {
                                                              value:
                                                                topic.IsSelected,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  topic,
                                                                  "IsSelected",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "topic.IsSelected"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-list-item-content",
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "text-left"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    topic.TopicName
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        }),
                                        1
                                      )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "gen-report-btn",
                      attrs: {
                        outlined: "",
                        color: "indigo",
                        loading: _vm.generatingReport
                      },
                      on: {
                        click: function($event) {
                          return _vm.onGenerate()
                        }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "loader",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "gen-report-btn-loader" },
                                [
                                  _vm._v(" Generating... "),
                                  _c("v-progress-linear", {
                                    attrs: {
                                      indeterminate: "",
                                      rounded: "",
                                      height: "21"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c("v-icon", [_vm._v("mdi-shuffle-variant")]),
                      _vm._v(" Generate ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          staticClass: "pdf-dialog",
          model: {
            value: _vm.pdfDialog,
            callback: function($$v) {
              _vm.pdfDialog = $$v
            },
            expression: "pdfDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "pa-0 report-preview" },
            [
              _c(
                "v-system-bar",
                [
                  _c("v-spacer"),
                  _c(
                    "v-icon",
                    {
                      on: {
                        click: function($event) {
                          _vm.pdfDialog = false
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              ),
              _c("vue-pdf-app", {
                attrs: {
                  "page-scale": "page-fit",
                  pdf: _vm.pdfArrayBuffer,
                  config: _vm.pdfViewerConfig,
                  "file-name": _vm.reportFileName
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.missingTopicDialog,
            callback: function($$v) {
              _vm.missingTopicDialog = $$v
            },
            expression: "missingTopicDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h6" }, [
                _vm._v(" Missing Report Topics ")
              ]),
              _c("v-card-text", [
                _vm._v(" Please select at least one topic for the report ")
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: {
                        click: function($event) {
                          _vm.missingTopicDialog = false
                        }
                      }
                    },
                    [_vm._v(" OK ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }